/* ==========================================================================
   Al Basit Fragrance — product card size-pill behaviour
   Vanilla JS. Lets a shopper switch size (variant) directly on a grid card
   without leaving the page: updates price, compare-at price, the hidden
   variant id used by the quick add-to-cart form, and sold-out state.
   ========================================================================== */

(function () {
  'use strict';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(0);
    return (window.AB_MONEY_FORMAT || 'Rs. {{amount}}').replace('{{amount}}', amount);
  }

  document.querySelectorAll('[data-ab-card]').forEach(initCard);

  function initCard(card) {
    var dataEl = card.querySelector('[data-ab-card-variants]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var pills = card.querySelectorAll('[data-ab-size-pill]');
    if (!pills.length) return;

    var input = card.querySelector('[data-ab-variant-input]');
    var priceEl = card.querySelector('[data-ab-card-price]');
    var wasEl = card.querySelector('[data-ab-card-was]');
    var addBtn = card.querySelector('[data-ab-card-add]');

    function findVariant(id) {
      var match = null;
      variants.forEach(function (v) {
        if (String(v.id) === String(id)) match = v;
      });
      return match;
    }

    function selectVariant(id, pillEl) {
      var variant = findVariant(id);
      if (!variant) return;

      pills.forEach(function (p) { p.classList.remove('is-active'); });
      if (pillEl) pillEl.classList.add('is-active');

      if (input) input.value = variant.id;

      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      if (wasEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          wasEl.textContent = formatMoney(variant.compare_at_price);
          wasEl.style.display = '';
        } else {
          wasEl.style.display = 'none';
        }
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.setAttribute('aria-label', variant.available ? 'Add to cart' : 'Sold out');
      }
    }

    pills.forEach(function (pill) {
      if (pill.disabled) return;
      pill.addEventListener('click', function () {
        selectVariant(pill.getAttribute('data-ab-size-pill'), pill);
      });
    });
  }
})();
